export default __webpack_public_path__ + "static/media/logo-ikiga-white.c3ee7438.png";